import { ErrorHandler, inject, Injectable } from '@angular/core';
import { LoggerService } from '../feature/services/logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logger = inject(LoggerService);

  handleError(error: unknown) {
    try {
      console.error('Error:', error);
      this.logger.log(error);
    } catch (loggingError) {
      console.error('Original error:', error);
      console.error('Failed to log error:', loggingError);
    }
  }
}
